import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
import { Permissions } from 'app/model/shared/backend-api-response/permissions';

@Component({
  selector: 'app-useridle',
  templateUrl: './useridle.component.html',
  styleUrls: ['./useridle.component.scss'],
})
export class UseridleComponent implements OnInit {
  public timeout: any;
  public username: any;
  public action: any;
  public isConfirmationPage: boolean = false;
  rGuestBookMessages: RGuestMessages;
  rGuestBookPermissions: Permissions;
  constructor(
    public snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<UseridleComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public AppInitializer: LegacyBookInitService
  ) {
    this.timeout = data.timeout;
    this.username = data.name;
    this.rGuestBookMessages = this.AppInitializer.PropertyData.rGuestMessages;
    this.rGuestBookPermissions = this.AppInitializer.PropertyData.permissions;
    this.isConfirmationPage = data.isConfirmationPage;
  }

  ngOnInit() {
    if (this.isConfirmationPage && this.rGuestBookPermissions.functionalPermissions.confirmationPage_continueBookingButtonNameChange) {
      this.rGuestBookMessages.commonConstants.userIdleButton1 =
        this.rGuestBookMessages.confirmation.confirmationContinueBookingCustomButtonName;
    }
  }
  logout() {
    this.dialogRef.close('logout');
  }
  proceedtoWork() {
    this.dialogRef.close('proceedtoWork');
  }
  close() {
    this.dialogRef.close('timeout');
  }
}
